import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { GridFilters, initialStateList } from './GridFiltersReducer';
import TicketsType from '../types/TicketsType';

const initialState = {
  allTickets: { ...initialStateList },
  ticketsTypes: [],
  ticketDetails: {},
};

export const Tickets = handleActions(
  {
    ...GridFilters,
    [TicketsType.actions.fetchTicketsTypesSuccess]: (state, { payload }) => ({
      ...state,
      ticketsTypes: payload,
    }),
    [TicketsType.actions.fetchTicketsDetailsSuccess]: (state, { payload }) => ({
      ...state,
      ticketDetails: { ...payload },
    }),
  },
  initialState
);

const getTickets = (state) => state.Tickets;

export const getTicketsList = (state, list) => {
  const tickets = getTickets(state);
  return tickets[list] || undefined;
};
export const getTicketsTypes = createSelector(getTickets, (state) => state.ticketsTypes);
export const getTicketDetails = createSelector(getTickets, (state) => state.ticketDetails);
